module.exports = __webpack_public_path__ + "img/ic24ArrowB.2784a32a.svg";